// extracted by mini-css-extract-plugin
export default {"input_amount":"Input_input_amount__EGWX3"};